/**
 * A recording with its playback URL (a stable server URL that redirects to
 * short-lived storage URLs; the field name predates the redirect).
 * Used by comment components to link timestamps to recordings.
 */
export type Recording = {
  id: string;
  filename: string;
  signedAudioUrl: string;
};

/**
 * A recording enriched with the song metadata the global player needs.
 * Feedback components take these so a referenced take can be queued even on
 * pages (like setlists) whose recordings span multiple songs.
 */
export type PlayableRecording = Recording & {
  songId: string;
  songTitle: string;
  authorName: string | null;
};

/**
 * Extended recording with position, creation date, and duration.
 * Used by song detail pages and edit forms.
 * createdAt accepts both Date (from DB) and string (from API JSON serialization).
 */
export type RecordingWithMetadata = Recording & {
  position: number;
  createdAt: Date | string;
  durationSeconds: number;
};

/**
 * Href that downloads a recording as a file attachment.
 * The server streams the file with its display filename.
 */
export function recordingDownloadHref(recordingId: string): string {
  return `/api/recordings/${recordingId}/download`;
}
